module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"q76":"How can I access E-Drive Login Page?","a76-1":"Please acess "},"zh_hk":{"q76":"如何訪問 E-Drive 登錄頁面?","a76-1":"請訪問 "},"zh_cn":{"q76":"如何访问 E-Drive 登录页面?","a76-1":"请访问 "}}')
  delete Component.options._Ctor
}
